import firebaseApp from 'chat-common/firebase/connect'
import settings from 'chat-common/firebase/settings'
import firebase from 'firebase'
import "firebase/performance";
import { EventEmitter } from "events";
import { v4 } from 'uuid'
//firebase.firestore.setLogLevel('debug')

const eventEmitter = new EventEmitter();
const firestore = firebaseApp.firestore();
const perf = firebase.performance();
const auth      = firebaseApp.auth();
if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === 'true') {
  firestore.useEmulator("localhost", 8080);
  auth.useEmulator("http://localhost:9099");
}
export const FieldValue = firebase.firestore.FieldValue

export const signInAnonymously = async ( 
  onSuccess = () => {}, 
  onFail = (error) => {}, 
  onAuthStateChaned = (user) => {} 
) => {
  console.log(auth)
  auth.onAuthStateChanged(onAuthStateChaned)
  const result = await auth.signInAnonymously().catch(error => {
    return onFail(error)
  })
  console.log(result)
  await auth.setPersistence(firebase.auth.Auth.Persistence.NONE).catch(error => {
    return onFail(error)
  })
  onSuccess()
  return 
}


export const closeWindow = async (caseId,event) => {
  const doc = await firestore.collection('cases').doc(caseId).update({
    window: 'closed',
    event,
  })
  return doc
}

export const hiddenWindow = async (caseId) => {
  const doc = await firestore.collection('cases').doc(caseId).update({
    window: 'hidden',
    lastHiddenTime: FieldValue.serverTimestamp(),
  })
  return doc
}

export const visibleWindow = async (caseId) => {
  const doc = await firestore.collection('cases').doc(caseId).update({
    window: 'open',
    lastHiddenTime: null,
  })
  return doc
}

export const signInServiceAccount = async (
  onSuccess = () => {}, 
  onFail = (error) => {}, 
  onAuthStateChaned = (user) => {} 
) =>{
  //ブラウザのオフライン永続性を有効にし、パフォーマンスを向上させる
  //また、Caseに対して頻繁にAddされる場合
  //onSnapshotへ著しくパフォーマンスに影響を与えるため、この処理が必要となる。
  //https://firebase.google.com/docs/firestore/manage-data/enable-offline?hl=ja
  await firebase.firestore().enablePersistence().catch((err) => {
    if (err.code == 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
        alert("複数同ツールを開くことは出来ません。")
    } else if (err.code == 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...
        alert("お使いのブラウザでは、データ同期に遅延が発生する可能性があります。Chrome、Safari、Firefoxからの利用を推奨します。")
    }
    return onFail(err)
  })
  console.log("========Persistence enabled===========")
  console.log(auth)
  auth.onAuthStateChanged(onAuthStateChaned)
  const { email, pass } = settings.serviceAccount
  const result = await auth.signInWithEmailAndPassword(email,pass)
  .catch(error => {
    return onFail(error)
  })
  console.log(result)
  await auth.setPersistence(firebase.auth.Auth.Persistence.NONE).catch(error => {
    return onFail(error)
  })
  onSuccess()
  return
}

export const createForm = async (id,name,skill,service,usage,formItems,options=[],searchable=false)=>{
  if(!formItems instanceof FormItems){
    throw new Error('formItems is NOT FormItems instance.')
  }
  const doc = await firestore.collection('forms').
  add({
    id,
    name,
    skill,
    service,
    usage,
    items,
    options,
    searchable,
  })
  return doc
}
export const createNews = async (title,text,isEmergency,start,end) => {
  firestore.collection('news').add({
    title,
    text,
    isEmergency,
    start,
    end,
    createTime: FieldValue.serverTimestamp()
  })
}
export const listenSession = (sessionId, handleError) => {
  const unsubscibeSession = firestore.collection('sessions').
    doc(sessionId).
    onSnapshot(
      (doc) => {
        const data = doc.data()
        eventEmitter.emit(`session`, { sessionId, data })
        if (["abandoned", "concluded", "closed"].includes(data.caseStatus)) {
          unsubscibeSession()
          console.log("unsubscribe session successfully")
        }
      },
      handleError
    )
}
//userがcase
export const listenCase = (caseId, handleError) => {
  const unsubscibeCase = firestore.collection('cases').
    doc(caseId).
    onSnapshot(
      (doc) => {
        const data = doc.data()
        eventEmitter.emit(`case`, { caseId, data })
        if (["abandoned", "concluded", "closed"].includes(data.status)){
          unsubscibeCase()
          console.log("unsubscribe case successfully")
        }
      },
      handleError
    )
}
export const onStatusChange = (handle) => {
  eventEmitter.on('case', ({ caseId, data }) => {
    handle(caseId, data)
  })
}
export const onMessageChange = (handle) => {
  eventEmitter.on('session', ({ sessionId, data }) => {
    handle(sessionId, data)
  })
}
//staffがリクエストを監視
export const monitorCase = (staffId,skill) => {
  firestore.collection('cases').
    where('status', '==', 'open').
    where('staffId', '==', '').
    where('skill','==',skill)
    onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change, index) => {
        const { type, doc } = change
        console.log(type,doc.data(),doc.id)
        eventEmitter.emit(`${type}:request`, { doc, index })
      })
    })

  //作業中のケースの取得
  firestore.collection('cases').
    where('status', 'in', ['inProgress', 'closed']).
    where('staffId', '==', staffId).
    onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change, index) => {
        const { type, doc } = change
        console.log(type)
        eventEmitter.emit(`${type}:request`, { doc, index })
      })
    })
}


export const requestChat = async (contents, form = {}, skill = '',botMessageHistory=[], uid) => {
  console.log('requestChat',{
    contents,
    form,
    skill,
    botMessageHistory,
    uid
  })
  const sessionDocRef = await firestore.collection('sessions').
    add({
      messages:{
        [v4()]:{
          contents: {
            contentType: contents.contentType || '',
            contentUrl: contents.contentUrl || '',
            text: contents.text
          },
          createTime: FieldValue.serverTimestamp(),
          from: 'user'
        }
      },
      userReadline: -1,
      staffReadline: -1,
      uid,
      skill,
      userReplyTime: FieldValue.serverTimestamp()
    })
  const sessionId = sessionDocRef.id
  const caseDocRef = await firestore.collection('cases').
    add({
      form,
      firstMessage: contents.text,
      botMessageHistory,
      sessionId,
      lastUpdateTime: FieldValue.serverTimestamp(),
      openTime: FieldValue.serverTimestamp(),
      staffId:'',
      skill,
      uid,
      status: 'open',
    })
  return { sessionId, caseId: caseDocRef.id}
}

export const postMessage = async (sessionId, from, contents, updateReplyTime=false) => {
  const sessionDoc = await firestore.collection('sessions').doc(sessionId).get()
  const { messages = {} } = sessionDoc.data()
  const index = v4()
  const nextMessages = Object.assign( messages, {[index]: {
    contents: {
      contentType: contents.contentType || '',
      contentUrl: contents.contentUrl || '',
      text: contents.text || '',
    },
    createTime: FieldValue.serverTimestamp(),
    from,
    messageId: v4(),
  }})
  const baseData = {
    messages: nextMessages
  }
  const data = (updateReplyTime)?{
    staff: {...baseData, staffReplyTime: FieldValue.serverTimestamp()},
    user: {...baseData, userReplyTime: FieldValue.serverTimestamp()},
  }[from] : baseData
  console.log("postMessage Test:", updateReplyTime, sessionId, data)
  firestore.collection('sessions').doc(sessionId).update(data)
}
export const readMessage = (sessionId, from, index) => {
  firestore.collection('sessions').
    doc(sessionId).update({
      [`${from}Readline`]: index,
      updateTime: FieldValue.serverTimestamp()
    }).then((doc) => {

    })
}

export const closeChat = (caseId, sessionId, disconnectedBy) => {
  if(!caseId){
    throw new Error("caseId mustn't be null or undefined.")
  }
  if(!sessionId){
    throw new Error("sessionId mustn't be null or undefined.")
  }
  if(!['Agent','Visitor'].includes(disconnectedBy)){
    throw new Error('disconnectedBy mush be either "Agent" or "Visitor".')
  }
  const closedTime = FieldValue.serverTimestamp()
  const status = 'closed'
  firestore.collection('sessions').doc(sessionId).update({
    caseStatus: status,
    disconnectedBy,
    closedTime
  })
  firestore.collection('cases').doc(caseId).update({
    status,
    closedTime,
    lastUpdateTime: FieldValue.serverTimestamp(),
  })
}

export const abandon = async(caseId, sessionId) => {
  const targetCaseDocRef = firestore.collection('cases').doc(caseId)
  const targetSessionDocRef = firestore.collection('sessions').doc(sessionId)
  firestore.runTransaction(async (transaction) => {
    const caseDocRef = await transaction.get(targetCaseDocRef)
    const sessionDocRef = await transaction.get(targetSessionDocRef)
    if (!caseDocRef.exists) throw new Error('Case Document does not exist.')
    if (!sessionDocRef.exists) throw new Error('Session Document does not exist.')
    //data check
    const { status } = caseDocRef.data()
    if (status !== 'open') return Promise.reject("already-updated-case")
    transaction.update(targetCaseDocRef, {
      status: 'abandoned',
      abandonedTime: FieldValue.serverTimestamp(),
      lastUpdateTime: FieldValue.serverTimestamp(),
    })
    transaction.update(targetSessionDocRef, {
      caseStatus: 'abandoned',
      abandonedTime: FieldValue.serverTimestamp(),
      lastUpdateTime: FieldValue.serverTimestamp(),
    })
  }).catch((errorCode) => {
    console.log("failed", errorCode)
  });
}
export const setCache = async (key,data) => {
  return await firestore.collection('sfMaster').
  doc(key).
  set(data)
}
export const changeStaffStatus = async( staffId, from, to) => {
  const doc = await firestore.collection('statusHistory').
  add({
    staffId,
    from,
    to,
    timestamp: FieldValue.serverTimestamp(),
  })
  return doc
}
//exports.storage =   firebaseApp.storage()

export { firestore, auth }